// extracted by mini-css-extract-plugin
module.exports = {"container":"board-users-presence_container__xG4QH"};